import { render, staticRenderFns } from "./GameStateModal.vue?vue&type=template&id=e036fc52&scoped=true"
import script from "./GameStateModal.vue?vue&type=script&lang=js"
export * from "./GameStateModal.vue?vue&type=script&lang=js"
import style0 from "./GameStateModal.vue?vue&type=style&index=0&id=e036fc52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e036fc52",
  null
  
)

export default component.exports